/* eslint-disable */
// @ts-nocheck

import React, { useContext } from "react";
import Button, { Icons } from "../../buttons/Button";
import Breadcrumps from "../../pageHeaderComponents/Breadcrumps";
import ProfileDropdown from "../../dropdown/ProfileDropdown";

export default function ESPageHeader() {
  return (
    <div className="flex flex-row justify-between items-center h-16">
      <nav className="flex breadcrumb-nav" aria-label="Breadcrumb">
        <Breadcrumps />
      </nav>

      <div className="flex flex-row">
        <div className="w-[48px] h-[48px] rounded-2xl flex items-center justify-center profile-wrapper">
          <ProfileDropdown />
        </div>
      </div>
    </div>
  );
}
